import { Link } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";
import { Home, ArrowRight } from "lucide-react";
import { CALCOM_DEMO_URL } from "../config/demo";

export default function NotFoundPage() {
  usePageTitle("Page Not Found | CleanBid.ai");

  return (
    <div
      className="bg-[#0A0A0F] min-h-screen flex items-center justify-center px-4"
      data-testid="not-found-page"
    >
      {/* subtle radial glow behind the number */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 40% at 50% 40%, rgba(113,222,214,0.06) 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 text-center max-w-lg mx-auto">
        {/* 404 */}
        <p
          className="text-[10rem] sm:text-[12rem] font-black leading-none tracking-tighter select-none"
          style={{
            background:
              "linear-gradient(135deg, #1E1E2E 0%, #2A2A3E 50%, #1E1E2E 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            textShadow: "none",
          }}
          aria-hidden="true"
        >
          404
        </p>

        {/* accent line */}
        <div className="w-12 h-1 bg-[#71DED6] rounded-full mx-auto -mt-6 mb-8" />

        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#F4F4F8] mb-4">
          Page not found.
        </h1>
        <p className="text-[#8B8BA7] text-base leading-relaxed mb-10 max-w-sm mx-auto">
          This page may have moved or no longer exists. Let's get you back on
          track.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="not-found-home-button"
            className="inline-flex items-center gap-2 border border-[#1E1E2E] text-[#F4F4F8] font-semibold px-7 py-3 rounded-full text-sm hover:bg-[#111118] transition-colors duration-200"
          >
            <Home className="w-4 h-4" />
            Back to Home
          </Link>
          <a
            href={CALCOM_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="not-found-demo-button"
            className="inline-flex items-center gap-2 bg-[#71DED6] text-[#10151D] font-semibold px-7 py-3 rounded-full text-sm hover:scale-[1.02] hover:shadow-[0_0_20px_rgba(113,222,214,0.3)] transition-all duration-200"
          >
            Book a Demo
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        {/* subtle footer hint */}
        <p className="mt-12 text-[#3A3A5A] text-xs">
          Looking for something specific?{" "}
          <Link
            to="/contact"
            className="text-[#8B8BA7] hover:text-[#71DED6] transition-colors underline underline-offset-2"
          >
            Contact us
          </Link>
        </p>
      </div>
    </div>
  );
}
